const formatLabel = ({ row }) => {
  return (
    <span className={row.isRecent ? 'recent-filter-value' : undefined}>
      {row.label}
    </span>
  )
}

export default formatLabel
